const INITIAL_LOCATION_SEARCH_REGEX = /puan|filtreler|siralama|markalar|sayfa/g;
const INITIAL_TAG_LOCATION_SEARCH_REGEX = /puan|filtreler|siralama|markalar|kategori|sayfa/g;

const shouldRequestBanner = ({locationUrl, isTagPage = false}) => {
  const matchRegex = isTagPage ? INITIAL_TAG_LOCATION_SEARCH_REGEX : INITIAL_LOCATION_SEARCH_REGEX;
  const locationSearch = locationUrl?.includes('?') ? locationUrl?.split('?')?.[1] : locationUrl;
  const matches = locationSearch.match(matchRegex);

  return matches === null;
};

export {
  shouldRequestBanner
}
